// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"96":"Signin","187":"NotFound","362":"Dashboard","584":"DashboardDetail","850":"Addon"}[chunkId] || chunkId) + "." + {"96":"ed1c4230","187":"e2395f22","245":"a2c4d590","362":"efe27491","584":"0a043435","850":"3269bbc1"}[chunkId] + ".css";
};